import { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import logoImg from '../assets/dason-logo.jpg';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 h-[72px] transition-all duration-300 ${scrolled
        ? 'bg-[#0a0a0f]/80 backdrop-blur-md border-b border-white/10'
        : 'bg-transparent border-b border-transparent'
        } `}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex items-center justify-between h-full">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-3 group">
            <div className="relative w-12 h-12 flex items-center justify-center rounded-lg overflow-hidden">
              <img src={logoImg} alt="DASON AI Logo" className="w-full h-full object-contain" />
            </div>
            <span className="text-xl font-bold tracking-tight text-[var(--ds-text-primary)]">
              {t.navbar.logo}
            </span>
          </a>

          {/* Language Switcher */}
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-2 px-4 py-2 rounded-full border border-[var(--ds-border)] bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] transition-colors text-[var(--ds-text-primary)] text-sm font-medium"
          >
            <Globe className="w-4 h-4" />
            <span>{t.navbar.lang}</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
